import React, { Fragment } from 'react';
import { Button, Form } from 'antd';
import { setStateUserEnter } from 'app/actions/Users/user.enter.action';
import { FormattedMessage } from 'react-intl';
import AbstractMachine from './abstractMachine';
import userAPI from '../../../../API/user.service.api';
import {
  FORGOT_PASSWORD,
  LETTER_SENT,
} from '../../../../constants/enter.user.constants';

export default class ForgotPassword extends AbstractMachine {
  constructor(form, goTo) {
    super(form, goTo);

    this._name = FORGOT_PASSWORD;
    this._nextState = LETTER_SENT;
  }

  getName = () => {
    return this._name;
  };

  getTitle = () => {
    return (
      <FormattedMessage id="Change password" defaultMessage="Change password" />
    );
  };

  isShowFreePro = () => {
    return false;
  };

  onSubmit = () => {
    this._form.validateFields().then((values) => {
      const { userEmail } = values;
      this._goTo(null, this.sendNewPassword, userEmail);
    });
  };

  sendNewPassword = (dispatch, userEmail) => {
    userAPI.sendNewPassword(userEmail).then(
      (resp) => {
        let state = {};
        if (resp.code === 200) {
          state = { name: this._nextState, userEmail, error: resp.response };
        } else {
          state = {
            name: this._name,
            userEmail,
            error: resp.message,
          };
        }
        dispatch(setStateUserEnter(state));
      },
      (error) => {
        dispatch(setStateUserEnter({ error })); // need to contitune!!!
      }
    );
  };

  render(props) {
    return (
      <>
        {this.getMainInput(props)}
        <Form.Item className="width100" style={{ marginBottom: '18px' }}>
          <Button
            type="primary"
            className="ant-btn-primary width100"
            onClick={this.onSubmit}
          >
            <span>
              <FormattedMessage
                id="Send new password"
                defaultMessage="Send new password"
              />
            </span>
          </Button>
        </Form.Item>
      </>
    );
  }
}
